// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"aeb2bb9f","488":"98719e61"}[chunkId] + ".chunk.js";
};